import React from "react";
import { BrowserRouter as Router, Routes, Route, useRoutes } from "react-router-dom";

import Home from './pages/home.js';

const App = () => {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router basename="/">
      <App />
    </Router>
  );
};

export default AppWrapper;